import { FgHelp, type FgHelpProps } from '../../../help/FgHelp'
import type { QoeHelpId } from './qoeHelpContent'
import { QOE_HELP_SOURCE } from './qoeHelpStore'
import './QoeHelp.css'

/** One help id, or several ids that describe the same spot (the first is primary, the rest render as related sections). */
export type QoeHelpRef = QoeHelpId | readonly [QoeHelpId, ...QoeHelpId[]]

export type QoeHelpProps = Omit<FgHelpProps, 'id' | 'also' | 'source'> & { id: QoeHelpId; also?: readonly QoeHelpId[] }

/** FgHelp over the QoE registry, whose ids are typed and whose content loads on first use. */
export function QoeHelp(props: QoeHelpProps) {
  return <FgHelp {...props} source={QOE_HELP_SOURCE} />
}

/** Renders a `QoeHelpRef` (single id or id list) as one help button. */
export function QoeHelpFor({ help }: { help?: QoeHelpRef }) {
  if (!help) return null
  return typeof help === 'string' ? <QoeHelp id={help} /> : <QoeHelp id={help[0]} also={help.slice(1)} />
}
